import { useQuery } from 'react-query'
import { get } from 'framework/api/http'

export interface EmailAlertCardsQueryVariables {
  partnerId?: string
  processDescription?: string
  search?: string
  take: number
  skip: number
}

/* Get the paginated Email Alerts "report card" list — grouped by (Partner, Service, Process) */
export const getEmailAlertCardsList = async (queryData: any) => {
  const { partnerId, processDescription, search, take, skip } = queryData
    .queryKey[1] as EmailAlertCardsQueryVariables

  const params = new URLSearchParams()
  if (partnerId) params.append('partnerId', partnerId)
  if (processDescription)
    params.append('serviceNameDescription', processDescription)
  if (search) params.append('search', search)
  params.append('take', String(take))
  params.append('skip', String(skip))

  const res = await get(`/NotificationRecipient/Cards?${params.toString()}`)
  return res.data
}

export const useGetEmailAlertCardsList = (
  queryData: EmailAlertCardsQueryVariables,
  options?: { enabled?: boolean },
) => {
  return useQuery(['emailAlertCards', queryData], getEmailAlertCardsList, {
    refetchOnWindowFocus: true,
    keepPreviousData: true,
    enabled: options?.enabled ?? true,
  })
}

export default useGetEmailAlertCardsList
